export const LEGAL_PUBLIC_PATHS = {
  terms_of_service: "/terms",
  privacy_policy: "/privacy",
  cookie_notice: "/cookies",
  email_notifications_policy: "/email-notifications-policy",
  broker_partner_terms: "/broker-partner-terms",
};

export function publicPathForDocumentType(documentType) {
  return LEGAL_PUBLIC_PATHS[documentType] || "/terms";
}

export function documentTypeFromPublicPath(pathname) {
  const entry = Object.entries(LEGAL_PUBLIC_PATHS).find(([, path]) => path === pathname);
  return entry?.[0] || null;
}
